/* =====================================================================================================================
   batida-v7-degustacja.js: "Kup degustację" (sections/batida-v7-degustacja.liquid; prototype #deg-buy).
   Adds the picked product (1 szt., no line properties) with /cart/add.js, dispatches the full /cart.js as
   theme:cart:change and opens the cart drawer (window.__batidaOpenCart), like the letter card on the categories.
   ===================================================================================================================== */
(function () {
  'use strict';
  var busy = false;
  function root() { return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, ''); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-v7dg-buy]');
    if (!btn || btn.disabled || busy) return;
    var id = +btn.getAttribute('data-variant');
    if (!id) return;
    var box = btn.closest('[data-v7dg]'), msg = box && box.querySelector('[data-v7dg-msg]');
    busy = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (msg) { msg.textContent = ''; msg.classList.remove('is-err'); }
    fetch(root() + '/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      return fetch(root() + '/cart.js', { credentials: 'same-origin' }).then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      try { document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart } })); } catch (err) { /* old browsers */ }
      if (msg) msg.textContent = btn.getAttribute('data-added') || '';
      if (typeof window.__batidaOpenCart === 'function') window.__batidaOpenCart();
    }).catch(function () {
      if (msg) { msg.classList.add('is-err'); msg.textContent = btn.getAttribute('data-error') || ''; }
    }).then(function () {
      busy = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  });
})();
